<template>
  <div class="notFound" ref="notFound">
    <div class="marginTopDiv"></div>
    <div class="notImg"></div>
    <div class="notExplain">找不到页面了:(</div>
    <el-button type="primary" size="small" @click="back">返回</el-button>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    back () {
      let menu1 = this.$store.state.menus.menu1
      let menu2 = this.$store.state.menus.menu2
      let menuAll = []
      for (let i = 0; i < menu1.length; i++) {
        if (menu1[i].url !== '/') {
          menuAll.push(menu1[i])
        } else {
          for (let j = 0; j < menu2.length; j++) {
            if (menu1[i].id === menu2[j].pId) {
              if (menu2[j].url !== '/') {
                menuAll.push(menu2[j])
              }
            }
          }
        }
      }
      for (let i = 0; i < menuAll.length; i++) {
        if (menuAll[i].url !== '/') {
          this.$router.push(menuAll[i].url)
          this.$store.dispatch('activeMenu', menuAll[i].url)
          break
        }
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.notFound
  box-sizing border-box
  width 100%
  height 100%
  background-color #F1F2F6
  text-align center
  .marginTopDiv
    height 22.2%
  .notImg
    margin 0 auto
    width 702px
    height 272px
    background-image url('./404.png')
    background-repeat no-repeat
    background-size 100% 100%
  .notExplain
    margin-top 2px
    margin-bottom 65px
    line-height 22px
    font-size 16px
    color #3F3F3F
    text-align center
</style>



// WEBPACK FOOTER //
// src/components/notFound/notFound.vue